module.exports = __webpack_public_path__ + "images/testimonial-google.webp";